/**
* @Author 22030124/xieyq
* @Date 2023-11-21 11:27:45
* @Description 权限vuex入口js
*/
// 格式化路由参数
import { formatRoute } from '../utils/route.js'
import Vue from 'vue'

// state
const state = {
  // 路由
  routes: [],
  openedPage: JSON.parse(sessionStorage.getItem('openedPage') || '{}'),
  openedApp: JSON.parse(sessionStorage.getItem('openedApp') || '[]')
}
// mutations
const mutations = {
  SET_ROUTES: (state, routes) => {
    state.routes = routes
  },
  // 设置打开的应用列表
  ADD_OPENED_PAGE: (state, pageData) => {
    if (!state.openedPage[pageData.appId]) {
      Vue.set(state.openedPage, pageData.appId, [])
    }
    // 判断是否已存在相同context的应用
    const exists = state.openedPage[pageData.appId].some(page => page.url === pageData.url)
    // 如果不存在相同context的应用，则添加
    if (!exists) {
      state.openedPage[pageData.appId].push(pageData)
      sessionStorage.setItem('openedPage', JSON.stringify(state.openedPage))
    }
  },
  // 添加更新openedPage的方法
  UPDATE_OPENED_PAGE: (state, { appId, openedPage }) => {
    state.openedPage[appId] = openedPage
    sessionStorage.setItem('openedPage', JSON.stringify(state.openedPage))
  },
  // 设置打开的应用列表
  ADD_OPENED_APP: (state, appData) => {
    // 判断是否已存在相同context的应用
    const exists = state.openedApp.some(app => app.url === appData.url)
    // 如果不存在相同context的应用，则添加
    if (!exists && appData.url) {
      state.openedApp.push(appData)
      sessionStorage.setItem('openedApp', JSON.stringify(state.openedApp))
    }
  },
  // 根据ID删除打开的应用
  CANCEL_OPENED_APP: (state, id) => {
    const index = state.openedApp.findIndex(app => app.id === id)
    if (index !== -1) {
      state.openedApp.splice(index, 1)
      sessionStorage.setItem('openedApp', JSON.stringify(state.openedApp))
    }
  },
  // 根据URL删除打开的页面
  CANCEL_OPENED_PAGE: (state, item) => {
    const url = item.url
    const index = state.openedPage[item.appId].findIndex(page => page.url === url)
    if (index !== -1) {
      state.openedPage[item.appId].splice(index, 1)
      sessionStorage.setItem('openedPage', JSON.stringify(state.openedPage))
    }
  }
}

// 请求
const actions = {
  /**
   * 生成路由
   */
  generateRoutes({ commit }, menuList) {
    return new Promise((resolve) => {
      const accessedRoutes = formatRoute(menuList)
      // 赋值路由
      commit('SET_ROUTES', accessedRoutes)
      resolve(accessedRoutes)
    })
  },
  // 添加actions来处理取消打开页面的逻辑
  cancelOpenedPage({ commit }, item) {
    commit('CANCEL_OPENED_PAGE', item)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
